// The survey absolute expiry is a day (YYYY-MM-DD): the backoffice API saves it as 23:59:59.999 UTC of that day.
// The browser time zone is never used: the date picker only shows the calendar day.

const pad = (value) => String(value).padStart(2, '0');

// Today in UTC, YYYY-MM-DD
export const todayUTC = (now = new Date()) => now.toISOString().slice(0, 10);

// Day of the expiry from the API value (ISO string, 23:59:59.999 UTC) or from the form value (YYYY-MM-DD)
export const toExpiryDay = (value) => (value ? String(value).slice(0, 10) : null);

// Local Date showing the given day in the date picker
export const dayToPickerDate = (day) => {
    if (!day) {
        return null;
    }
    const [year, month, date] = day.split('-').map(Number);
    return new Date(year, month - 1, date);
};

// Day chosen in the date picker
export const pickerDateToDay = (date) => (date ? `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` : null);

// Days are compared as YYYY-MM-DD strings
export const isExpiryDayPast = (day, now = new Date()) => !!day && day < todayUTC(now);
